<template>
    <i>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90" aria-hidden="true" focusable="false" role="img" class="v-icon__svg">
            <g>
                <g id="Layer" focusable="false">
                    <g>
                        <path d="M69.5,49.7c-5.6,0-9-2.8-9-7.6h6.3c0,1.9.9,2.8,2.9,2.8s2.5-.7,2.5-1.9-1-1.7-3.7-2.4c-4-1.1-7.6-2.3-7.6-7s3.2-6.9,8.6-6.9,8.4,2.4,8.4,7.2h-6.1c0-1.6-.9-2.5-2.6-2.5s-2.3.7-2.3,1.7,1,1.6,3.8,2.3c4.1,1,7.7,2.3,7.7,7.2,0,4.4-3.4,7.1-8.9,7.1M50.2,49.2l-1.1-4h-7l-1.1,4h-6.2l7-22h7.5l7,22h-6.1ZM25.3,49.2l-1.1-4h-7l-1.1,4h-6.1l7-22h7.5l7,22h-6.2ZM88.9,26.1l-6.5-7.2c-.8-.8-1.8-1.3-3-1.3H10.5c-1.1,0-2.2.5-3,1.3l-6.5,7.2c-.6.8-1,1.8-1,2.8v41.4c0,2.3,1.8,4.1,4,4.1h2.7c2.2,0,4-1.9,4-4.1v-5.5c0-1,.4-2,1.1-2.8l2.8-3.1c.8-.9,1.8-1.3,3-1.3h54.7c1.1,0,2.1.4,2.8,1.2l3.2,3.2c.8.8,1.2,1.8,1.2,2.9v5.3c0,2.3,1.8,4.1,4,4.1h2.5c2.2,0,4-1.9,4-4.1V28.9c0-1-.4-2-1.1-2.8" />
                        <path d="M45.7,31.5c-.6,2.4-1.2,5-1.9,7.4l-.4,1.5h4.5l-.4-1.5c-.7-2.4-1.3-5-1.8-7.4" />
                        <path d="M20.8,31.5c-.6,2.4-1.2,5-1.9,7.4l-.4,1.5h4.5l-.4-1.5c-.6-2.4-1.3-5-1.8-7.4" />
                    </g>
                </g>
            </g>
        </svg>
    </i>
</template>

<style scoped>
svg {
    display: inline-block;
    vertical-align: middle;
}
</style>
